import { useCallback } from 'react';
import { DomainSearchGateModule } from '../../../../module/domainSearchGate.module';
export const useShowMoreDomainSuggestions = _ref => {
  let searchTerm = _ref.searchTerm,
    fetchNextPage = _ref.fetchNextPage;
  return useCallback(() => {
    DomainSearchGateModule.internals.bi.onBngGeneralAction == null || DomainSearchGateModule.internals.bi.onBngGeneralAction({
      action: 'select',
      button_name: 'show_more',
      domain: searchTerm,
      search_term: searchTerm
    });
    fetchNextPage();
  }, [fetchNextPage, searchTerm]);
};
//# sourceMappingURL=useShowMoreDomainSuggestions.js.map